import { spawn } from 'redux-saga/effects';
import watchSeniorAuthRecord from './getSeniorRecord';

export default function* watchPrimaryRecord() {
  yield spawn(watchSeniorAuthRecord);
}
